import { Component, OnInit } from '@angular/core';
import { ThemeOptions } from '../../../../../theme-options';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/auth.service';
import { ServiceService } from 'src/app/services/service.service';
@Component({
  selector: 'app-user-box',
  templateUrl: './user-box.component.html',
})
export class UserBoxComponent implements OnInit {
  user_id: any;
  public profile_image: string = '';


  constructor(public globals: ThemeOptions, private auth: AuthService, private router: Router,
    private location: Location, private ServerService: ServiceService) {
    this.user_id = localStorage.getItem('user_name');
    this.profile();
  }


  ngOnInit() {

    this.ServerService.currentProfileImage$.subscribe((img: string) => {
      this.profile_image = img;
    });
  }

  profile() {
    const api_req: any = {
      action: "get_details",
      phone_number: this.user_id,
      name: '',
      email: ''
    };

    this.ServerService.sendzohoServer(api_req).subscribe((response: any) => {
      if (response.success == true || response.success == "true") {
        this.profile_image = response.data.profile_image;
        localStorage.setItem('profile_image', response.data.profile_image)
      } else {
        // error handling
      }
    });

  }

  closeMobileHeader() {
    this.globals.toggleHeaderMobile = false;
  }
  log_details() {
    const api_req: any = {
      action: "logout",
      phone_number: this.user_id

    };


    this.ServerService.sendzohoServer(api_req).subscribe((response: any) => {
      if (response.success == true || response.success == "true") {
        // success handling
        // console.log("Logout saved successfully");
      } else {
        // error handling
        // console.error("Log saving failed");
      }
    });
  }

  logout() {

    Swal.fire({
      title: 'Are you sure?',
      text: "Would you Like to Log Out",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'LogOut'
    }).then((result) => {
      if (result.value) {

        localStorage.removeItem("api_version");
        localStorage.removeItem("client_id");
        localStorage.removeItem("ps_key");
        localStorage.removeItem("nas_id");
        localStorage.removeItem("user_name");
        localStorage.clear();
        this.auth.logout();
        this.log_details();
        this.router.navigate(['/login']);
      } else {

      }
    },
      (error) => {
        //console.log(error);
      });


  }
}
